import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../shared/LoadingSpinner";
import SingleArticle from "./SingleArticle";
import { article } from "./ArticleInterfaces";
import { isEmpty } from "lodash";
import { HOST } from "../../services/constants";
import AccountMenu from "components/shared/Menu";

const categoryNames: Record<number, string> = {
  1: "RENT AN INFLATABLE",
  2: "BUY AN INFLATABLE",
  3: "RENT PARTY EQUIPMENT",
};

const ArticleList = () => {
  const { category } = useParams(); // cat_id como string
  const [isLoading, setIsLoading] = useState(true);
  const [articleData, setArticleData] = useState<article[]>([]);

  const getData = async() => {
    try {
      const url = category
        ? `${HOST}/catalogmx/index.php/article/features?category=${category}`
        : `${HOST}/catalogmx/index.php/article/features`;

      const response = await fetch(url);
      const data = await response.json();
      setArticleData(data);
    } catch (error) {
      console.error("Error fetching articles:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [category]);

  // const renderTitle = () => {
  //   const catId = Number(category);
  //   return categoryNames[catId]
  //     ? `Showing articles for: ${categoryNames[catId]}`
  //     : "All Articles";
  // };

  return <>
    <AccountMenu />
    <div style={{ maxWidth: "900px", minWidth: "380px", marginInline: "auto" }}>
      {/* <h2 style={{ textAlign: "center" }}>{renderTitle()}</h2> */}
      {isLoading ? (
        <LoadingSpinner />
      ) : !isEmpty(articleData) ? (
        articleData.map((articleElement: article) => (
          <SingleArticle key={articleElement.id} data={articleElement} />
        ))
      ) : (
        <p>No Data Available</p>
      )}
    </div>
  </>;
};

export default ArticleList;
